import axios from "axios";
import { apiURL } from './api.js';

// Function to get all plans (authenticated)
export const getAllPlans = async () => {
    try {
        const token = localStorage.getItem('authToken');

        const response = await axios.get(`${apiURL}/plans`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        });
        
        if (response.status !== 200) {
            throw new Error('Failed to fetch plans');
        }
        return response.data;
    } catch (error) {
        console.error('Error fetching plans:', error);
        throw error;
    }
};

// Function to get all plans (public - no auth required)
export const getPublicPlans = async () => {
    try {
        const response = await axios.get(`${apiURL}/public/plans`, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        
        if (response.status !== 200) {
            throw new Error('Failed to fetch plans');
        }
        return response.data;
    } catch (error) {
        console.error('Error fetching public plans:', error);
        throw error;
    }
};

// Function to get plan by ID
export const getPlanById = async (id) => {
    try {
        const response = await axios.get(`${apiURL}/plans/${id}`);
        
        if (response.status !== 200) {
            throw new Error('Failed to fetch plan');
        }
        return response.data;
    } catch (error) {
        console.error('Error fetching plan:', error);
        throw error;
    }
};

// Function to create Stripe checkout session (via Laravel)
export const createStripeCheckout = async (userId, planId, currency = 'EUR') => {
    try {
        const token = localStorage.getItem('authToken');

        const response = await axios.post(`${apiURL}/subscriptions/stripe/checkout`,
            {
                user_id: userId,
                plan_id: planId,
                currency: currency,
                success_url: `${window.location.origin}/payment-success`,
                cancel_url: `${window.location.origin}/payment-cancelled`
            },
            {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            }
        );

        if (response.status !== 200 && response.status !== 201) {
            throw new Error('Failed to create checkout session');
        }
        return response.data;
    } catch (error) {
        console.error('Error creating Stripe checkout:', error);
        throw error;
    }
};
